// extracted by mini-css-extract-plugin
module.exports = {"RejectBtn":"ScraperItem_RejectBtn__2Jw8D","Selected":"ScraperItem_Selected__3G5Ce"};